import { assetUrl as appAssetUrl, localUrl as appLocalUrl } from './app-path.js';
import Highcharts from 'highcharts';
import initializeWeatherSummaryTelemetry from './components/weather-summary-telemetry';
initializeWeatherSummaryTelemetry();
import 'owl.carousel';
import Main from './main';
import './monkey-patch';
import common from './components/common';
import thirtyDaysModal from './components/thirty-days-modal';
import { getForecastChartTheme } from './components/theme-tokens';
import favoriteCitiesHomepage from './components/favorite-cities-homepage';

const finiteForecastValue = value => {
	if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
	const number = Number(value);
	return Number.isFinite(number) ? number : null;
};

const finiteRange = (values, operation) => {
	const finite = values.filter(value => typeof value === 'number' && Number.isFinite(value));
	return finite.length ? operation(...finite) : null;
};

const renderHourlySeries = (id, options) => {
	const values = options.series.reduce((all, series) => all.concat(series.data), [])
		.map(point => point && typeof point === 'object' ? point.y : point);
	const target = document.getElementById(id);
	if (!values.some(value => typeof value === 'number' && Number.isFinite(value))) {
		if (target) {
			target.textContent = 'Sem dados';
			target.setAttribute('data-weather-unavailable', 'hourly-variable');
		}
		return;
	}
	if (target) target.removeAttribute('data-weather-unavailable');
	Highcharts.chart(id, options);
};

const Forecast = {
	themeEventsBound: false,
	/**
	 * Identifica na aba principal em qual pagina de previsão o usuário está
	 * All Forecasts
	 */
	activeTab: () => {
		const tab = $('[data-page=has-tab]').data('tab');
		$('[data-item="' + tab + '"]').addClass('-active');
	},

	/**
	 * Identifica na aba principal em qual pagina de previsão o usuário está (MOBILE)
	 * All Forecast
	 */
	menuMobile: () => {
		const tab = $('[data-page=forecast]').data('tab');
		if (tab) {
			const left = $('[data-navigation="' + tab + '"]')
				.addClass('-active')
				.offset().left;

			const innerWidth = window.innerWidth;
			const scrollLeft = innerWidth / 2 - 60;
			const fixedNavigation = document.getElementById('fixedNavigation');

			fixedNavigation.addEventListener('scroll', ev => {
				let scroll = ev.target.scrollLeft;
				const left = document.getElementById('sideNavigatorLeft');
				const right = document.getElementById('sideNavigatorRight');

				if (scroll < 50) left.classList.add('-hidden');
				else left.classList.remove('-hidden');

				if (scroll > 350) right.classList.add('-hidden');
				else right.classList.remove('-hidden');
			});

			fixedNavigation.scrollTo({
				left: left - scrollLeft,
				behavior: 'smooth',
			});
		}
	},
	/**
	 * Carrosel de cupom de descontos
	 * All Forecasts
	 */
	initCarousel: () => {
		$.ajax({
			type: 'GET',
			url: 'https://descontos.climatempo.com.br/widget/homepage-widget',
			dataType: 'xml',
			success: function (xml) {
				let item;

				$(xml)
					.find('item')
					.each(function () {
						let img = $(this).find('image').text();
						let a = $(this).find('alt-text').text();
						let href = $(this).find('link').text();

						item = `
                  <div>
                    <img src="${img}" class="image" alt="">
                    <a href="${href}" class="link" target="_blank">${a}</a>
                  </div>
                 `;

						$(`#couponCarousel`).append(item);
					});

				$('[data-carousel="owl.coupon"]').owlCarousel({
					dots: true,
					lazyLoad: true,
					loop: true,
					responsive: {
						0: {
							items: 1,
						},
						1024: {
							items: 5,
						},
					},
				});
			},
		});
	},
	/**
	 * Requisita dados de previsão horária e diária
	 * ForecastToday, Tomorrow, Weekend, Fifteen days
	 */
	getHourlyForecast: () => {
		const tab = document.getElementById('mainContent').getAttribute('data-tab');

		$('.controlWrapperChartHourlyForecast').each(function () {
			let id = $(this).data('id');
			let day = $(this).data('day');
			let response = JSON.parse(JSON.stringify($(this).data('hourly')));
			if (!Array.isArray(response) || !response.length) {
				$(`#loadingHourlyChart${id}`).addClass('_none');
				return;
			}

			let data = Forecast.formatterHourlyForecast(response, id);
			Forecast.renderHourlyChart(data, id);

			if (tab === 'today' || tab === 'tomorrow') {
				let response = JSON.parse(JSON.stringify($(this).data('daily')));
				let data = Forecast.formatterDailyIndexes(response, id);
				Forecast.renderDailyIndexes(data, id);
			}
		});
	},
	/**
	 * Formata dados horários para serem renderizados
	 * ForecastToday, Tomorrow, Weekend, Fifteen days
	 * @param response
	 * @param id
	 * @returns {{
	 * condition: [*,*,*,*,*,*,*,*,*,*,*,*,*],
	 * wind: Array,
	 * rain: Array,
	 * temperatures: Array,
	 * pressure: Array,
	 * humidity: Array,
	 * hour: Array,
	 * formattedHour: Array
	 * }}
	 */
	formatterHourlyForecast: (response, id) => {
		const acronym = document
			.getElementById('mainContent')
			.getAttribute('data-ac');
		let temperatures = [];
		let wind = [],
			rain = [],
			humidity = [],
			pressure = [],
			hour = [],
			formattedHour = [];
		let dailyForecastIcons = document.querySelectorAll(
			`[data-icon-id='${id}']`,
		);
		let iconDawn = dailyForecastIcons[0]?.getAttribute('data-icon') || null;
		let iconMorning = dailyForecastIcons[1]?.getAttribute('data-icon') || null;
		let iconAfternoon = dailyForecastIcons[2]?.getAttribute('data-icon') || null;
		let iconNight = dailyForecastIcons[3]?.getAttribute('data-icon') || null;
		let condition = [
			iconDawn,
			iconDawn,
			iconDawn,
			iconMorning,
			iconMorning,
			iconMorning,
			iconAfternoon,
			iconAfternoon,
			iconAfternoon,
			iconNight,
			iconNight,
			iconNight,
			iconNight,
		];

		if (acronym !== 'BR') {
			condition = [
				iconDawn,
				iconDawn,
				iconMorning,
				iconMorning,
				iconAfternoon,
				iconAfternoon,
				iconNight,
				iconNight,
			];
		}

		response.forEach(item => {
			let hours = item.date.split('T')[1].split(':')[0];
			if (acronym !== 'BR') {
				if (hours % 3 == 0) {
					temperatures.push(finiteForecastValue(item.temperature?.temperature));
					wind.push(item.wind || null);
					rain.push(item.rain || null);
					humidity.push(item.humidity || null);
					pressure.push(item.pressure || null);
					hour.push(hours);
					formattedHour.push(hours + 'h');
				}
			} else {
				if (hours % 2 == 0 || hours == 23) {
					temperatures.push(finiteForecastValue(item.temperature?.temperature));
					wind.push(item.wind || null);
					rain.push(item.rain || null);
					humidity.push(item.humidity || null);
					pressure.push(item.pressure || null);
					hour.push(hours);
					formattedHour.push(hours + 'h');
				}
			}
		});

		return {
			condition,
			wind,
			rain,
			temperatures,
			pressure,
			humidity,
			hour,
			formattedHour,
		};
	},
	/**
	 * Formata dados diários para serem renderizados
	 * ForecastToday, Tomorrow, Weekend, Fifteen days
	 * @param response
	 * @param id
	 * @returns {{dates: Array, mosquito: Array, iuv: Array, flu: Array}}
	 */
	formatterDailyIndexes: (response, id) => {
		let dates = [];
		let mosquito = [];
		let iuv = [];
		let flu = [];
		let skin = [];

		response.forEach(item => {
			dates.push(item.date);
			mosquito.push(
				item.indexes.mosquito.incidence ? item.indexes.mosquito.incidence : 1,
			);
			iuv.push(item.indexes.iuv.incidence);
			flu.push(item.indexes.flu.incidence);
			skin.push(item.indexes.skin.incidence);
		});

		return {
			dates,
			mosquito,
			iuv,
			flu,
			skin,
		};
	},
	/**
	 * Renderiza gráfico com dados horários
	 * ForecastToday, Tomorrow
	 * @param data
	 * @param index
	 */
	renderHourlyChart: (data, index) => {
		// data = dados horários; index = índice do card
		const acronym = document
			.getElementById('mainContent')
			.getAttribute('data-ac');
		const theme = getForecastChartTheme();
		const temperatures = data.temperatures;
		const position = new Date().getHours();
		const condition = data.condition;
		const rain = data.rain;
		const wind = data.wind;
		const humidity = data.humidity;
		const pressure = data.pressure;

		/**
		 * Metodo que pinta a celula da previsao horaria de acordo com a hora atual
		 * @param cell
		 * @param key
		 */
		function highlightCell(cell, key) {
			let divider = 2;

			if (acronym !== 'BR') divider = 3;

			let hour = Math.floor(position / divider);
			if (hour == key) {
				cell.style.backgroundColor = theme.highlightBand;
			}
		}

		let hours = [
			'00h',
			'02h',
			'04h',
			'06h',
			'08h',
			'10h',
			'12h',
			'14h',
			'16h',
			'18h',
			'20h',
			'22h',
			'23h',
		];
		let divider = 2;

		if (acronym !== 'BR') {
			hours = ['00h', '03h', '06h', '09h', '12h', '15h', '18h', '21h'];
			divider = 3;
		}

		// BEGIN: insere os dados de condição e horários na ul correspondente
		condition.forEach((item, key) => {
			let conditionLi = document.createElement('li');
			let conditionImg = document.createElement('img');
			conditionImg.src = item ? appAssetUrl('/dist/images/v2/svg/') + item + '.svg' : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
			conditionImg.className = '_width-40';
			conditionImg.width = '40';
			conditionImg.height = '40';

			let conditionHour = document.createElement('p');
			conditionHour.className = 'hour';
			conditionHour.innerHTML = hours[key];

			conditionLi.classList.add('item');
			highlightCell(conditionLi, key);
			conditionLi.appendChild(conditionImg);
			conditionLi.appendChild(conditionHour);

			if (acronym !== 'BR') conditionLi.classList.add('-large');

			$(`#conditionList${index}`).append(conditionLi);
		});
		// END: insere os dados de condição na ul correspondente

		const maxTemp = parseInt(
			$(`#wrapperForecastCard${index} .max-temp`).html(),
		);
		const minTemp = parseInt(
			$(`#wrapperForecastCard${index} .min-temp`).html(),
		);

		let arrTemperatures = [];
		let arrRain = [];
		let arrWind = [];
		let arrHumidity = [];
		let arrPressure = [];

		arrRain = rain.map(function (rain) {
			return finiteForecastValue(rain?.precipitation);
		});

		arrWind = wind.map(function (wind) {
			return { y: finiteForecastValue(wind?.velocity), direction: wind?.direction };
		});

		arrHumidity = humidity.map(function (humidity) {
			return finiteForecastValue(humidity?.relativeHumidity);
		});

		arrPressure = pressure.map(function (pressure) {
			return finiteForecastValue(pressure?.pressure);
		});

		arrTemperatures = temperatures.map(function (temperature) {
			if (temperature === null) return null;
			if (Number.isFinite(maxTemp) && temperature >= maxTemp) {
				return maxTemp;
			} else if (Number.isFinite(minTemp) && temperature <= minTemp) {
				return minTemp;
			} else {
				return temperature;
			}
		});

		// busca maior e menos valor dentro dos arrays
		const smallerTemp = finiteRange(temperatures, Math.min);
		const biggerTemp = finiteRange(temperatures, Math.max);
		const smallerRain = finiteRange(arrRain, Math.min);
		const highestRain = finiteRange(arrRain, Math.max);
		const smallerWind = finiteRange(arrWind.map(wind => wind.y), Math.min);
		const highestWind = finiteRange(arrWind.map(wind => wind.y), Math.max);
		const smallerHumidity = finiteRange(arrHumidity, Math.min);
		const highestHumidity = finiteRange(arrHumidity, Math.max);
		const smallerPressure = finiteRange(arrPressure, Math.min);
		const highestPressure = finiteRange(arrPressure, Math.max);

		if (highestRain) {
			const modalInfoChart = document.getElementById(`modalInfoChart${index}`);
			const modalInfoNoRain = document.getElementById(
				`modalInfoNoRain${index}`,
			);

			if (modalInfoChart) modalInfoChart.remove();
			if (modalInfoNoRain) modalInfoNoRain.remove();
		}

		Highcharts.wrap(
			Highcharts.SVGRenderer.prototype,
			'init',
			function (proceed) {
				proceed.apply(this, Array.prototype.slice.call(arguments, 1));

				let elm = this.box.children[0];
				if (elm && elm.tagName === 'desc') {
					elm.remove();
				}
			},
		);

		renderHourlySeries(`hourlyRainChart${index}`, {
			chart: {
				type: 'column',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: data.formattedHour,
				plotBands: [
					{
						from: Math.floor(position / divider) - 0.5,
						to: Math.floor(position / divider) + 0.5,
						color: theme.highlightBand,
					},
				],
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: smallerRain == 0 ? 0 : smallerRain - 1,
				max: highestRain + 1,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			series: [
				{
					name: 'Chuva',
					data: arrRain,
					color: theme.axis,
					dataLabels: {
						enabled: true,
						style: {
							color: theme.axis,
							fontSize: '16px',
						},
					},
				},
			],
		});

		renderHourlySeries(`hourlyTemperatureChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: 0,
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: data.formattedHour,
				plotBands: [
					{
						from: Math.floor(position / divider) - 0.5,
						to: Math.floor(position / divider) + 0.5,
						color: theme.highlightBand,
					},
				],
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: smallerTemp - 1,
				max: biggerTemp + 3,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							var x = parseInt(this.x.split(':')[0]);
							let result = x % 2 === 0 || x === 23 ? this.y : ' ';

							if (acronym !== 'BR') {
								result = x % 3 === 0 ? this.y : ' ';
							}

							return result;
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.hourlyTemperatureLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.hourlyTemperatureLine,
				},
			},
			series: [
				{
					name: 'Temperatura',
					data: arrTemperatures,
					color: theme.hourlyTemperatureFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		renderHourlySeries(`hourlyWindChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: data.formattedHour,
				plotBands: [
					{
						from: Math.floor(position / divider) - 0.5,
						to: Math.floor(position / divider) + 0.5,
						color: theme.highlightBand,
					},
				],
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: smallerWind - 1,
				max: highestWind + 5,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							var x = parseInt(this.x.split(':')[0]);
							let result = x % 2 === 0 || x === 23 ? this.y : ' ';

							if (acronym !== 'BR') {
								result = x % 3 === 0 ? this.y : ' ';
							}

							return result;
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.hourlyWindLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.hourlyWindLine,
				},
			},
			series: [
				{
					name: 'Vento',
					data: arrWind,
					color: theme.hourlyWindFill,
					dataLabels: {
						useHTML: true,
						enabled: true,
						style: {
							fontSize: '16px',
						},
						formatter: function () {
							return `<span style="display:block; text-align: center">
            <span class="arrow -up -medium -green-wind _inline-block" style="transform:rotate(${Forecast.getWindPosition(this.point.direction)}deg);"></span><br>
            <span style="color:${theme.axis};">${this.point.direction}</span><br>${this.point.y}</span>`;
						},
					},
				},
			],
		});

		renderHourlySeries(`hourlyHumidityChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: data.formattedHour,
				plotBands: [
					{
						from: Math.floor(position / divider) - 0.5,
						to: Math.floor(position / divider) + 0.5,
						color: theme.highlightBand,
					},
				],
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: smallerHumidity == 0 ? 0 : smallerHumidity - 5,
				max: highestHumidity + 5,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							var x = parseInt(this.x.split(':')[0]);
							let result = x % 2 === 0 || x === 23 ? this.y : ' ';

							if (acronym !== 'BR') {
								result = x % 3 === 0 ? this.y : ' ';
							}

							return result;
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.hourlyHumidityLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.hourlyHumidityLine,
				},
			},
			series: [
				{
					name: 'Umidade',
					data: arrHumidity,
					color: theme.hourlyHumidityFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		renderHourlySeries(`hourlyPressureChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: data.formattedHour,
				plotBands: [
					{
						from: Math.floor(position / divider) - 0.5,
						to: Math.floor(position / divider) + 0.5,
						color: theme.highlightBand,
					},
				],
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: smallerPressure == 0 ? 0 : smallerPressure - 5,
				max: highestPressure + 5,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							var x = parseInt(this.x.split(':')[0]);
							let result = x % 2 === 0 || x === 23 ? this.y : ' ';

							if (acronym !== 'BR') {
								result = x % 3 === 0 ? this.y : ' ';
							}

							return result;
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.pressureLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.pressureLine,
				},
			},
			series: [
				{
					name: 'Pressão',
					data: arrPressure,
					color: theme.pressureFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		const loadingHourlyChart = document.getElementById(
			`loadingHourlyChart${index}`,
		);
		if (loadingHourlyChart) loadingHourlyChart.remove();
	},
	/**
	 * Renderiza gráfico com índices diários
	 * ForecastToday, Tomorrow, Weekend, Fifteen days
	 * @param data
	 * @param index
	 */
	renderDailyIndexes: (data, index) => {
		// data = dados diários; index = índice do card
		const theme = getForecastChartTheme();
		const dates = data.dates;

		const mapper = arr => {
			return arr.map((item, i) =>
				highlightCellDay(dates[i])
					? { y: item, dataLabels: { className: '-bold' } }
					: { y: item },
			);
		};
		const arrMosquito = mapper(data.mosquito);
		const arrIuv = mapper(data.iuv);
		const arrFlu = mapper(data.flu);
		const arrSkin = mapper(data.skin);

		/**
		 * Metodo que pinta a celula da previsao diária de acordo com data
		 * @param key
		 */
		function highlightCellDay(key) {
			const today = new Date();
			const day = today.getDate();
			const month = today.getMonth() + 1;
			const tmp = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}`;
			return tmp === key;
		}

		dates.forEach((item, key) => {
			let iuvIcon = 1;
			if (arrIuv[key].y == 2 || arrIuv[key].y == 3) iuvIcon = 2;
			if (arrIuv[key].y == 4 || arrIuv[key].y == 5) iuvIcon = 3;

			let conditionLi = document.createElement('li');

			let conditionSpanMosquito = document.createElement('span');
			conditionSpanMosquito.className = `-condition-icons -icon-mosquito _none conditions-icon-mosquito-${arrMosquito[key].y}`;
			conditionSpanMosquito.width = '26';
			conditionSpanMosquito.height = '33';

			let conditionSpanIuv = document.createElement('span');
			conditionSpanIuv.className = `-condition-icons -icon-iuv _none conditions-icon-iuv-${iuvIcon}`;
			conditionSpanIuv.width = '35';
			conditionSpanIuv.height = '35';

			let conditionSpanFlu = document.createElement('span');
			conditionSpanFlu.className = `-condition-icons -icon-flu conditions-icon-flu-${arrFlu[key].y}`;
			conditionSpanFlu.width = '25';
			conditionSpanFlu.height = '25';

			let conditionSpanSkin = document.createElement('span');
			conditionSpanSkin.className = `-condition-icons -icon-skin _none conditions-icon-skin-${arrSkin[key].y}`;

			let conditionDate = document.createElement('p');
			conditionDate.className = 'hour';
			conditionDate.innerHTML = item;

			conditionLi.className = highlightCellDay(item) ? 'item -bold' : 'item';
			conditionLi.appendChild(conditionSpanMosquito);
			conditionLi.appendChild(conditionSpanIuv);
			conditionLi.appendChild(conditionSpanFlu);
			conditionLi.appendChild(conditionSpanSkin);
			conditionLi.appendChild(conditionDate);

			$(`#daysList`).append(conditionLi);
		});

		Highcharts.wrap(
			Highcharts.SVGRenderer.prototype,
			'init',
			function (proceed) {
				proceed.apply(this, Array.prototype.slice.call(arguments, 1));
				let elm = this.box.children[0];
				if (elm && elm.tagName === 'desc') {
					elm.remove();
				}
			},
		);

		Highcharts.chart(`indexMosquitoChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: dates,
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: 0,
				max: 4,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							switch (this.y) {
								case 1:
									return 'Baixo';
								case 2:
									return 'Moderado';
								case 3:
									return 'Alto';
							}
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.mosquitoLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.mosquitoLine,
				},
			},
			series: [
				{
					name: 'Mosquito',
					data: arrMosquito,
					color: theme.mosquitoFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		Highcharts.chart(`indexIuvChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: dates,
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: 0,
				max: 6,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							switch (this.y) {
								case 1:
									return 'Baixa';
								case 2:
									return 'Moderada';
								case 3:
									return 'Alta';
								case 4:
									return 'Muito alta';
								case 5:
									return 'Extrema';
							}
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.iuvLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.iuvLine,
				},
			},
			series: [
				{
					name: 'Índice UV',
					data: arrIuv,
					color: theme.iuvFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		Highcharts.chart(`indexFluChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: dates,
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: 0,
				max: 4,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							switch (this.y) {
								case 1:
									return 'Risco baixo';
								case 2:
									return 'Previna-se';
								case 3:
									return 'Atenção';
							}
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.fluLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.fluLine,
				},
			},
			series: [
				{
					name: 'Gripe/Resfriado',
					data: arrFlu,
					color: theme.fluFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});

		Highcharts.chart(`indexSkinChart${index}`, {
			chart: {
				type: 'areaspline',
				margin: [0, 0, 0, 0],
				backgroundColor: theme.surface,
				plotBackgroundColor: theme.surface,
				style: {
					fontFamily: 'Roboto-Regular',
				},
			},
			title: {
				text: '',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},
			tooltip: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			xAxis: {
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineColor: 'transparent',
				lineWidth: 0,
				categories: dates,
				labels: {
					enabled: false,
				},
			},
			yAxis: {
				min: 0,
				max: 4,
				gridLineWidth: 0,
				minorGridLineWidth: 0,
				lineWidth: 0,
				lineColor: 'transparent',
				showAxis: false,
				title: {
					text: ' ',
				},
				labels: {
					enabled: false,
				},
			},
			plotOptions: {
				areaspline: {
					dataLabels: {
						color: theme.axis,
						enabled: true,
						formatter: function () {
							switch (this.y) {
								case 1:
									return 'Sem alerta';
								case 2:
									return 'Previna-se';
								case 3:
									return 'Atenção';
							}
						},
					},
					marker: {
						fillColor: theme.pointFill,
						lineWidth: 2,
						lineColor: theme.skinLine,
						enabled: true,
						symbol: 'circle',
						radius: 4,
						states: {
							hover: {
								//enabled: false
							},
						},
					},
					fillOpacity: 1,
					lineColor: theme.skinLine,
				},
			},
			series: [
				{
					name: 'Ressecamento de pele',
					data: arrSkin,
					color: theme.skinFill,
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '16px',
						},
					},
				},
			],
		});
	},
	/**
	 * Requisita e renderiza a quantidade de tweets de chuva no pedagua na ultima hora
	 * ForecastNow
	 */
	loadPedaguaSocial: () => {
		const idLocale = document
			.getElementById('mainContent')
			.getAttribute('data-id-locale');
		// Only for São Paulo, Belo Horizonte and Rio de Janeiro
		if (idLocale == 3477 || idLocale == 6879 || idLocale == 5959) {
			const url = appLocalUrl(`/json/pedagua/social/total?idLocale=${idLocale}`);
			const xhttp = new XMLHttpRequest();
			const wrapperPedaguaTwits = document.querySelector(
				'#wrapperPedaguaTwits',
			);

			if (wrapperPedaguaTwits) {
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						const total = JSON.parse(this.response);

						document.getElementById('pedaguaTwits').innerText =
							`${total} tweets`;
						wrapperPedaguaTwits.classList.add('_block');
						wrapperPedaguaTwits.classList.remove('_none');
					}
				};

				xhttp.open('GET', url, true);
				xhttp.send();
			}
		}
	},
	/**
	 * Requisita e renderiza a quantidade de alagamentos na ultima hora
	 * ForecastNow
	 */
	loadRecentFlood: () => {
		const idLocale = document
			.getElementById('mainContent')
			.getAttribute('data-id-locale');
		if (idLocale == 3477) {
			const url = appLocalUrl(`/json/monitoring/flood/recent/total?idLocale=${idLocale}`);
			const xhttp = new XMLHttpRequest();
			const wrapperRecentFlood = document.querySelector('#wrapperRecentFlood');

			if (wrapperRecentFlood) {
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						const total = JSON.parse(this.response);

						document.getElementById('pedaguaRecentFlood').innerText =
							`${total} pontos`;
						wrapperRecentFlood.classList.add('_block');
						wrapperRecentFlood.classList.remove('_none');
					}
				};

				xhttp.open('GET', url, true);
				xhttp.send();
			}
		}
	},
	/**
	 * Renderiza banner em modais e mapas
	 * All Forecasts
	 */
	renderBanner: () => {
		$(document).on('click', '.actRenderBanner', function () {
			if (typeof googletag.defineSlot === 'undefined') return;
			const banner = $(this).data('banner');
			const forecastPage = $('#mainContent').data('forecast-page');
			let slot,
				slotMobile,
				slot2 = null;

			switch (banner) {
				case 'video':
					slot = googletag
						.defineSlot(
							`/1030473/D_${forecastPage}_retangulo_video`,
							[
								[336, 280],
								[300, 250],
							],
							`D_${forecastPage}_retangulo_video`,
						)
						.addService(googletag.pubads());
					break;
				case 'realTime':
					slot = googletag
						.defineSlot(
							`/1030473/D_${forecastPage}_retangulo_temporeal`,
							[
								[336, 280],
								[300, 250],
							],
							`D_${forecastPage}_retangulo_temporeal`,
						)
						.addService(googletag.pubads());
					break;
				case 'collaborative':
					slot = googletag
						.defineSlot(
							`/1030473/D_${forecastPage}_retangulo_colaborativo`,
							[
								[336, 280],
								[300, 250],
							],
							`D_${forecastPage}_retangulo_colaborativo`,
						)
						.addService(googletag.pubads());
					break;
				// case 'mais5dias_1':
				//   slot = googletag.defineSlot(`/1030473/D_15dias_retangulo_2`, [[336,280],[300,250],[728,90]], `D_15dias_retangulo_2`).addService(googletag.pubads())
				//   slot2 = googletag.defineSlot(`/1030473/D_15dias_lateral_fixo_2`, [[300,600],[300,250],[160,600],[120, 600]], `D_15dias_lateral_fixo_2`).addService(googletag.pubads())
				//   slotMobile = googletag.defineSlot(`/1030473/M_15dias_retangulo_2`, [[300, 250], [320, 100], [300, 100], [300, 50], [320, 50]], `M_15dias_retangulo_2`).addService(googletag.pubads())
				//   break
				// case 'mais5dias_2':
				//   slot = googletag.defineSlot(`/1030473/D_15dias_retangulo_3`, [[336,280],[300,250],[728,90]], `D_15dias_retangulo_3`).addService(googletag.pubads())
				//   slot2 = googletag.defineSlot(`/1030473/D_15dias_lateral_fixo_3`, [[300,600],[300,250],[160,600],[120, 600]], `D_15dias_lateral_fixo_3`).addService(googletag.pubads())
				//   slotMobile = googletag.defineSlot(`/1030473/M_15dias_retangulo_3`, [[300, 250], [320, 100], [300, 100], [300, 50], [320, 50]], `M_15dias_retangulo_3`).addService(googletag.pubads())
				//   break
				default:
					return true;
			}

			if (window.innerWidth < 1024) {
				if (slotMobile) googletag.pubads().refresh([slotMobile]);
			} else {
				if (slot) googletag.pubads().refresh([slot]);
				if (slot2) googletag.pubads().refresh([slot2]);
			}
		});
	},
	/**
	 * Controla ação de ver mais dias
	 * Forecast Fifteen Days
	 */
	openMoreDays: () => {
		$(document).on('click', '.actOpenMoreDays', function () {
			let count = $(this).data('count');
			let maxCount = $(this).data('max-count');
			let nextCount = count + 1;
			let max = nextCount * 5;

			$(this).data('count', nextCount);
			$(this).data('banner', `mais5dias_${nextCount}`);

			$(`[data-banners-block=${nextCount}]`).removeClass('_none');

			for (let i = count * 5 + 1; i <= max; i++) {
				$(`#wrapperForecastCard${i}`).removeClass('_none');
			}

			if (nextCount === maxCount) $('.actOpenMoreDays').remove();
		});
	},
	/**
	 * Requisita informações do fds das cidades favoritas do usuario logado
	 * Forecast weekend
	 */
	renderWeatherWeekendByFavoritesLocales: () => {
		const url = appLocalUrl(`/json/myclimatempo/user/weatherNextWeekenByFavoritesLocales`);
		const xhttp = new XMLHttpRequest();

		try {
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200 && this.response) {
					const response = JSON.parse(this.response);

					if (response.length) {
						response.forEach(item => {
							let locale = item.data[0].locale;
							let weather = item.data[0].weather;

							let li = `<li class="favorite-list">
                      <div class="row">
                        <div class="col-12">
                          <p class="-bold">${locale.name}</p>
                        </div>
                      </div>`;

							weather.forEach(data => {
								let date = data.date.split('-');
								const datePt = `${date[2]}/${date[1]}/${date[0]}`;

								li += `<div class="row _margin-t-15">
                        <div class="col-6 _flex">
                          <p>${datePt}</p>
                        </div>
                        <div class="col-3 _flex _justify-center">
                          <p class="_flex _align-center">
                            <span class="arrow -down -small _margin-r-10 _inline-block"></span>
                            ${data.temperature.min}º
                          </p>
                        </div>
                        <div class="col-3 _flex _justify-center">
                          <p class="_flex _align-center">
                            <span class="arrow -up -small _margin-r-10 _inline-block"></span>
                            ${data.temperature.max}º
                          </p>
                        </div>
                      </div>`;
							});

							li += `</li>`;

							$('#listFavoritesLocalesWeekend').append(li);
						});

						$('#updatedCardFavoritesLocales').removeClass('_none');
						$('#baseCardFavoritesLocales').addClass('-no-bottom');
					} else {
						msg = `<p class="-gray _center">
                    Você ainda não adicionou nenhuma localidade favorita :(
                  </p>
                  <p class="_center">
                    <a href="${appLocalUrl(`/meu-climatempo`)}" class="-bold -dark-blue">Vá até o painel e adicione</a>.
                  </p>`;

						$('#cardFavoritesLocales').append(msg);
					}

					$('#cardFavoritesLocales').removeClass('_none');
					$('#loadingFavoritesLocales').remove();
				}
			};

			xhttp.open('GET', url, true);
			xhttp.send();
		} catch (e) {}
	},
	/**
	 * Detalhamento de dados
	 * Forecast Today, Tomorrow
	 */
	controlCharts: () => {
		const legends = {
			rain: {
				name: 'Chuva',
				unit: 'Milímetros (mm)',
			},
			temperature: {
				name: 'Temperatura',
				unit: 'Celsius (&deg;C)',
			},
			wind: {
				name: 'Direção e intensidade do vento',
				unit: 'Quilômetros por hora (Km/h)',
			},
			humidity: {
				name: 'Umidade do ar',
				unit: '%',
			},
			pressure: {
				name: 'Pressão atmosférica',
				unit: '(hPa)',
			},
			flu: {
				name: 'Gripe/Resfriado',
				unit: 'Segundo a temperatura e umidade do ar',
			},
			mosquito: {
				name: 'Proliferação de mosquitos',
				unit: 'Segundo a temperatura e probabilidade de chuva',
			},
			iuv: {
				name: 'Índice UV',
				unit: 'Segundo o cálculo baseado na precipitação, ozônio e cobertura de nuvem',
			},
			skin: {
				name: 'Ressecamento de pele',
				unit: 'Segundo a probabilidade de chuva e umidade do ar',
			},
		};

		$(document).on('click', '.actControlHourlyCharts', function () {
			const chart = $(this).data('name');
			const id = $(this).data('id');

			// active clicked tab
			const rows = $(`#hourlyForecast${id}`).data('hourly');
			const rainValues = Array.isArray(rows) ? rows.map(row => finiteForecastValue(row?.rain?.precipitation)).filter(value => value !== null) : [];
			const hasHourlyValues = rainValues.length > 0 && Math.max(...rainValues) === 0;
			$(`[data-chart-type=hourly${id}]`).removeClass('-active');
			$(this).addClass('-active');

			// show only one chart
			$(`[data-hourly-chart-id=${id}]`).addClass('_none');
			$(`[data-hourly-chart=${chart}${id}]`).removeClass('_none');

			// show modal no rain
			if (chart == 'rain' && hasHourlyValues) {
				$(`#modalInfoChart${id}`).addClass('-active').removeAttr('style');
				$(`#modalInfoNoRain${id}`).addClass('-active');
			} else {
				$(`#modalInfoChart${id}`).attr('style', 'display: none !important');
				$(`#modalInfoNoRain${id}`).removeClass('-active');
			}

			// change name and unit chart
			$(`#hourlyChartName${id}`).html(legends[chart].name);
			$(`#hourlyChartUnit${id}`).html(legends[chart].unit);
		});

		$(document).on('click', '.actControlIndexesCharts', function () {
			const chart = $(this).data('chart-index');
			$('[data-chart-index]').removeClass('-active');
			$('[data-index-chart]').addClass('_none');
			$(`[data-index-chart=${chart}]`).removeClass('_none');
			$(this).addClass('-active');

			$(`#indexChartName`).html(legends[chart].name);
			$(`#indexChartUnit`).html(legends[chart].unit);

			$('.-condition-icons').addClass('_none');

			if (chart === 'flu') {
				$('.-icon-flu').removeClass('_none');
			}

			if (chart === 'mosquito') {
				$('.-icon-mosquito').removeClass('_none');
			}

			if (chart === 'iuv') {
				$('.-icon-iuv').removeClass('_none');
			}

			if (chart === 'skin') {
				$('.-icon-skin').removeClass('_none');
			}
		});

		$(document).on('click', '.actControlChartType', function () {
			const id = $(this).data('id');

			$(`.actControlChartType`).removeClass('-active');
			$(this).addClass('-active');
			$(`.ctrCharts`).addClass('_none');
			$(`#wrapper${id}`).removeClass('_none');
		});
	},

	getWindPosition: direction => {
		const positions = {
			N: 180,
			NNE: 202.5,
			NE: 225,
			ENE: 247.5,
			E: 270,
			ESE: 292.5,
			SE: 315,
			SSE: 337.5,
			S: 0,
			SSW: 22.5,
			SW: 45,
			WSW: 67.5,
			W: 90,
			WNW: 112.5,
			NW: 135,
			NNW: 157.5,
		};
		return positions[direction];
	},

	rerenderThemeSensitiveCharts: () => {
		const wrappers = document.querySelectorAll(
			'.controlWrapperChartHourlyForecast',
		);

		if (!wrappers.length) return;

		wrappers.forEach(wrapper => {
			const id = wrapper.getAttribute('data-id');
			const chartTargets = [
				`hourlyRainChart${id}`,
				`hourlyTemperatureChart${id}`,
				`hourlyWindChart${id}`,
				`hourlyHumidityChart${id}`,
				`hourlyPressureChart${id}`,
				`indexFluChart${id}`,
				`indexMosquitoChart${id}`,
				`indexIuvChart${id}`,
				`indexSkinChart${id}`,
			];

			chartTargets.forEach(targetId => {
				const element = document.getElementById(targetId);
				if (!element) return;

				const chart = Highcharts.charts.find(
					instance => instance && instance.renderTo === element,
				);
				if (chart) {
					chart.destroy();
				}

				element.innerHTML = '';
			});

			const conditionList = wrapper.querySelector(`[data-id="conditionList"]`);
			if (conditionList) {
				conditionList.innerHTML = '';
			}

			const daysList = wrapper.querySelector(`[data-id="daysList"]`);
			if (daysList) {
				daysList.innerHTML = '';
			}
		});

		Forecast.getHourlyForecast();
	},

	bindThemeEvents: () => {
		if (Forecast.themeEventsBound) return;

		document.addEventListener('ct:themechange', () => {
			Forecast.rerenderThemeSensitiveCharts();
		});

		Forecast.themeEventsBound = true;
	},
};

common.handleFavoriteButtonClick();
common.viewData();
Main.init();
Forecast.activeTab();
Forecast.initCarousel();
Forecast.bindThemeEvents();
Forecast.getHourlyForecast();
Forecast.renderBanner();
Forecast.openMoreDays();
Forecast.loadPedaguaSocial();
Forecast.loadRecentFlood();
Forecast.menuMobile();
Forecast.controlCharts();
common.backToTopButton();
thirtyDaysModal.init();
favoriteCitiesHomepage.init();

if ($('#mainContent').data('forecast-page') == 'fds') {
	const isLogged = document.cookie.match(new RegExp('(^| )SESSID=([^;]+)'));
	if (isLogged) {
		Forecast.renderWeatherWeekendByFavoritesLocales();
	} else {
		$('#messageNotLoggedCardFavoritesLocales').removeClass('_none');
		$('#loadingFavoritesLocales').remove();
	}
}
